import React, { createContext, useContext, useState, useCallback } from 'react';

interface RefreshContextType {
  lastCheckInTime: number | null;
  triggerCheckInRefresh: () => void;
}

const RefreshContext = createContext<RefreshContextType>({
  lastCheckInTime: null,
  triggerCheckInRefresh: () => {},
});

export const RefreshProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [lastCheckInTime, setLastCheckInTime] = useState<number | null>(null);

  const triggerCheckInRefresh = useCallback(() => {
    setLastCheckInTime(Date.now());
  }, []);

  return (
    <RefreshContext.Provider value={{ lastCheckInTime, triggerCheckInRefresh }}>
      {children}
    </RefreshContext.Provider>
  );
};

export const useRefresh = () => {
  const context = useContext(RefreshContext);
  if (!context) {
    throw new Error('useRefresh must be used within a RefreshProvider');
  }
  return context;
};